module.exports = __webpack_public_path__ + "static/media/TempGraph.b24897a1.jpg";